import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.km2};
  margin-top: 80px;
`;

export const IllustrationWrapper = styled.div`
  text-align: center;
  margin-bottom: ${({ theme }) => theme.spacing.km6};
`;
